<mat-icon
  class="extra-large-icon"
  [matMenuTriggerFor]="beforeMenu"
  #trigger="matMenuTrigger"
  [class.menu-open]="trigger.menuOpen"
>more_horiz</mat-icon>

<mat-menu
  #beforeMenu="matMenu"
  class="global-menu"
  xPosition="before"
>
  <button
    mat-menu-item
    (click)="editNote()"
  >Edit</button>
  <button
    mat-menu-item
    (click)="deleteNote()"
  >Delete</button>
</mat-menu>
